module.exports = __webpack_public_path__ + "img/erp_case7.9d8a6ecb.png";